<template>
  <div>
    <div
      style="
        padding: 10px;
        background-color: #ffffff;
        height: 270px;
        box-shadow: 0 1px 4px 0 rgba(216, 216, 216, 0.5);
        border-radius: 4px;
      "
      v-if="config.property_data.is_map_show"
    >
      <baidu-map
        class="map"
        ak="gTdTn8mYZDr69tGrofsyhrEw"
        :center="center"
        :zoom="zoom"
        @ready="onMapReady"
      >
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-geolocation
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          :showAddressBar="true"
          :autoLocation="true"
        ></bm-geolocation>
        <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
        <bm-marker
          :position="curPosition"
          :dragging="true"
          animation="BMAP_ANIMATION_DROP"
        ></bm-marker>
      </baidu-map>
    </div>
    <div class="store-address">
      <div class="store-address-left">
        <img
          class="store-address-left-image"
          :src="config.property_data.map_icon"
        />
        <div class="store-address-left-title">
          {{ config.property_data.address || "详细地址" }}
        </div>
      </div>
      <div
        class="store-address-right"
        v-if="!config.property_data.is_mobile_show"
      >
        <img
          class="store-address-right-image"
          src="https://wdzg-file-online.oss-cn-hangzhou.aliyuncs.com/open_file2017122911052938107157145.png"
        />
      </div>
      <div
        class="store-address-mobile"
        v-if="config.property_data.is_mobile_show"
      >
        <img :src="config.property_data.mobile_icon" alt="" />
      </div>
    </div>
  </div>
</template>


<script>
import {
  BaiduMap,
  BmScale,
  BmNavigation,
  BmGeolocation,
  BmCityList,
  BmMarker,
} from "vue-baidu-map";

export default {
  name: "tms-contact-info",
  props: ["config"],

  data() {
    return {
      center: { lng: 120.047646, lat: 30.297612 },
      zoom: 18,
    };
  },

  components: {
    BaiduMap,
    BmGeolocation,
    BmNavigation,
    BmScale,
    BmCityList,
    BmMarker,
  },

  computed: {
    curPosition() {
      this.center.lat = this.config.property_data["latitude"];
      this.center.lng = this.config.property_data["longitude"];
      this.zoom = 18;
      return {
        lat: this.config.property_data["latitude"],
        lng: this.config.property_data["longitude"],
      };
    },
  },

  mounted() {},

  methods: {
    onMapReady() {
      //        this.curPosition = {
      //          lat: this.config.property_data['latitude'],
      //          lng: this.config.property_data['longitude']
      //        };
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>